import { useEffect, useState } from "react";
import {Routes,Route,Link} from "react-router-dom";
import Layout from "./sitel/demon/ui/layout";
import auth from "./sitel/demon/services/auth";
import { appInit } from "./services/api";
import AppContext,{emptyContext} from './services/appContext';
import { stepToUrl,possibleWizardSteps } from "./services/nextActionMatrix";

//routes
import Landing from "./routes/index";
import Step1Disclaimer from "./routes/requestWizard/step1disclaimer";
import Step2ExemptionForm from "./routes/requestWizard/step2ExemptionForm";
import Step3DocumentUpload from "./routes/requestWizard/step3documentupload";
import Step4Signature from "./routes/requestWizard/step4signature";

function App({basename}) {

  const [appData,setAppData] = useState(emptyContext);
  
  //app init
  useEffect(
    ()=>{
      appInit(
          (r)=>{
            console.log('RESPONSE from appInit',r);
            setAppData(r.data.payload);
          },
          (r)=>console.error('COULD NOT load existing exemptions',r)
      );

    },[]
  );

  //MAIN ROUTING LOGIC FOR THE APP
  return (
    <AppContext.Provider value={appData}>
    <Routes>
      <Route path="/" element={<Layout homeRelativeUrl={basename} user={auth.getCurrentUser()} siteTitle="Occupational Health Requests" />}>
          <Route index element={<Landing />} />
          <Route path={`${stepToUrl[possibleWizardSteps.aknowledgement]}/:exemptionType/:requestId`} element={<Step1Disclaimer />} />
          <Route path={`${stepToUrl[possibleWizardSteps.formFields]}/:exemptionType/:requestId`} element={<Step2ExemptionForm />} />
          <Route path={`${stepToUrl[possibleWizardSteps.fileUpload]}/:exemptionType/:requestId`} element={<Step3DocumentUpload />} />
          <Route path={`${stepToUrl[possibleWizardSteps.signature]}/:exemptionType/:requestId`} element={<Step4Signature />} />
      </Route>

      <Route path="*" element={<>
                                <h2>This page is no longer active.</h2>
                                <h3><Link to={'/'}>Return to dashboard page.</Link></h3>
                              </>
                                } />
    </Routes>
    </AppContext.Provider>
  );
}

export default App;
